<template lang="pug">
  .vendor-view-bid-result

    .vendor-view-bid-result--success(v-if="bidResult.successful_bidder")
      p {{ $t('恭喜，您的方案报价已被选中。') }}
      p {{ $t('请开始执行项目，并在项目结案后上传结案报告。') }}
    .vendor-view-bid-result--failed(v-else)
      p {{ $t('很抱歉通知您，您的方案报价未被选中。') }}
      p {{ $t('期待下次与您合作。') }}
</template>

<script>
import TitleBar from '@/components/TitleBar'
import ProcurementAuditView from '@/components/ProcurementAuditView'
import FooterButton from '@/components/FooterButton'
import axios from 'axios'

export default {
  components: {
    TitleBar,
    ProcurementAuditView,
    FooterButton
  },
  data () {
    return {
      bidResult: {
        type: Boolean,
        default: true
      }
    }
  },
  mounted () {
    this.fetchAuditResult()
  },
  methods: {
    fetchAuditResult () {
      axios
        .get('/management/subfinal/getBidResult', {
          params: {
            sub_final_scope_id: this.$store.state.campaign.subFinalScopeId
          }
        })
        .then((res) => {
          this.bidResult = res
        })
    }
  }
}
</script>

<style lang="stylus">
.vendor-view-bid-result__main
  margin-left 20px

.vendor-view-bid-result--success
.vendor-view-bid-result--failed
  font-size $font-large
  display flex
  flex-direction column
  align-items center
  > p
    text-align center
  > p:nth-child(1)
    margin-bottom 0

.vendor-view-bid-result--success
  color $blue

.vendor-view-bid-result--failed
  color $red
  > p:nth-child(1)
    width 940px

.vendor-view-bid-result__button
  display flex
  justify-content center
</style>
